module.exports = __webpack_public_path__ + "img/case-closed.6e5e5010.png";